import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';

import useTable from "../components/useTable"
import Controls from "../components/controls/Controls";
import { Dimmer } from '../components/spinner';


import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from 'axios';

const CatalogoActividadEconomica = props => {

    /*  variables de estados */

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [activo, setActivo] = useState(true);


    const headCells = [
        { id: 'codigociu', label: 'CODIGO CIU', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'codigoactividad', label: 'CODIGO ACTIVIDAD', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'anios', label: 'AÑO', width: '60px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'descripcion', label: 'DESCRIPCION', width: '600px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'idactividad', label: 'ID', width: '10px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'accion', label: '', width: '120px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
    ]

    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.codigociu.toLowerCase().includes(target.value.toLowerCase())
                            || x.codigoactividad.toLowerCase().includes(target.value.toLowerCase())
                            || x.anios.toString().trim().includes(target.value)
                            || x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                            || x.idactividad.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarActividadesTodas = (anios) => {

        let endpoint = `${op.conexion}/api/catalogo/actividades?anios=${anios}`;

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data)

                var acti = []
                for (let i = 0; i < response.data.length; i++) {
                    acti.push({
                        idactividad: response.data[i].idactividad,
                        codigociu: response.data[i].codigociu,
                        codigoactividad: response.data[i].codigoactividad,
                        anios: response.data[i].anios,
                        descripcion: response.data[i].descripcion,
                        alicuota: response.data[i].alicuota,
                        minimo: response.data[i].minimo
                    })
                }
                setRecords(acti)
            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }


    const handleCloseMensa = () => {
        setMostrar(false);
        seleccionarActividadesTodas(props.anio ? props.anio : localStorage.getItem("efiscalanio"));
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelaCatActi();
    }


    const seleccionarLista = (index) => (event) => {


        blanquear();
        props.onHideAceptaCatActi(values[0].idActi, values[0].codciu, values[0].codacti, values[0].descrip, values[0].alicuo, values[0].mini);

    };

    const seleccionarFila = (index) => (event) => {

        setItemSelect(index);
        setActivo(false);
        var idActi = recordsAfterPagingAndSorting()[index].idactividad;
        var codciu = recordsAfterPagingAndSorting()[index].codigociu;
        var codacti = recordsAfterPagingAndSorting()[index].codigoactividad;
        var descrip = recordsAfterPagingAndSorting()[index].descripcion;
        var alicuo = recordsAfterPagingAndSorting()[index].alicuota;
        var mini = recordsAfterPagingAndSorting()[index].minimo;

        var datos = [];

        datos.push({
            idActi,
            codciu,
            codacti,
            descrip,
            alicuo,
            mini

        })
        setValues(datos);
    };


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{
                backgroundColor:'rgba(0, 0, 0, 0.521)'
            }}
            backdrop="static"
            keyboard={false}
            onShow={() => { seleccionarActividadesTodas(props.anio ? props.anio : localStorage.getItem("efiscalanio")) }}
        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>Seleccionar Actividades Económicas.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idactividad} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "80px", verticalAlign: "middle" }}>{item.codigociu}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "80px", verticalAlign: "middle" }}>{item.codigoactividad}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "60px", verticalAlign: "middle" }}>{item.anios}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "600px", verticalAlign: "middle" }}>{item.descripcion}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "10px", verticalAlign: "middle" }}>{item.idactividad}</td>

                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} onClick={seleccionarLista()}><i className="fas fa-check-circle"> Aceptar</i> </button>

                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-2"><i className="fa"> Cancelar</i></button>

            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoActividadEconomica;